const GENERIC_SERVER_IMAGES = [
  'apple-ii',
  'bleep-bloop',
  'enigma',
  'potato',
  'you-gotta-be-kitten-me',
];

// genericServerImageIndex returns the index into GENERIC_SERVER_IMAGES
// that is used for the provided originName. The algorithm is consistent
// and should return the same index for the same origin name (i.e. it's
// not randomized).
function genericServerImageIndex(originName) {
  const charCodeSum = originName.split('').
    map((c) => c.charCodeAt(0)).
    reduce((m, v) => m + v);
  return charCodeSum % GENERIC_SERVER_IMAGES.length;
}

// OriginThumbnail returns a promise that should resolve to the URL of a thumbnail image for the
// given origin name.
//
// First, it attempts to load the "expected" origin thumbnail (for origin thumbnails that exist).
// If that succeeds, this returns an object URL for the thumbnail blob (to avoid requesting the
// image again). If the request 404s (meaning there's no thumbnail for this origin), it resolves
// to a relative URL for one of several "generic" server images (defined in GENERIC_SERVER_IMAGES).
export function OriginThumbnail($http, $q, originName) {
  return $q(function(resolve, reject) {
    // First, try to get the normally-named thumbnail
    $http({
      method: 'GET',
      url: `/assets/images/origins/${originName}.jpg`,
      responseType: 'arraybuffer', // so we get binary data rather than a string
      'Interceptor-Ignore-Errors': true, // to tell the interceptor not to alert on an error
    }).
      then((response) => {
        const contentType = response.headers('content-type');
        if (contentType.toLowerCase().startsWith('image/')) {
          // Success! Return an object URL with the contents.
          const blob = new Blob([response.data], { type: contentType});
          resolve((window.URL || window.webkitURL).createObjectURL(blob));
        } else {
          // The admin CloudFront distribution turns 403s/404s into 200s returning
          // index.html so that direct links into admin work correctly. That means
          // that we're not likely to actually get 403s/404s (as handled by the
          // block below), but will get a 200 with a non-image content type.
          // So this block assumes we _would_ have gotten a 404 and uses the generic
          // image.
          resolve(`/assets/images/origins/${GENERIC_SERVER_IMAGES[genericServerImageIndex(originName)]}.jpg`);
        }
      }).catch((err) => {
        if (err.status == 403 || err.status == 404) {
          // 404 -- use a generic image
          resolve(`/assets/images/origins/${GENERIC_SERVER_IMAGES[genericServerImageIndex(originName)]}.jpg`);
        } else {
          // Not sure what went wrong here, so reject with the error.
          reject(err);
        }
      });
  });
};


// WEBPACK FOOTER //
// ./utils/origin_thumbnail.js